var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "text-character-wrapper" },
    [
      _c(_setup.ElementLibrarySelector, {
        attrs: {
          disabled: _setup.disabled.common,
          "element-list": _setup.model.fontMap,
          "library-id": _setup.model.fontLibraryId,
          "library-type": _setup.FONT_TYPE,
          "selected-position": _setup.model.fontOption,
          "mixed-element-list": _setup.model.isFontMapMixed,
          "mixed-library": _setup.model.isFontLibraryIdMixed,
        },
        on: {
          "pick-library": _setup.pickFontLibrary,
          "remove-library": _setup.removeFontLibrary,
          "load-option": _setup.onLoadOption,
          "option-selected": _setup.onFontSelected,
          "remove-map-option": _setup.removeFontOptionFromMap,
          "options-reordered": _setup.onFontOptionsReordered,
        },
      }),
      _vm._v(" "),
      !_setup.type.warpText
        ? [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-8 d-flex align-items-center" },
                [
                  _c(_setup.CInput, {
                    staticClass: "flex-fill",
                    attrs: {
                      type: "decimal",
                      step: ".01",
                      placeholder: _setup.model.placeholder,
                      min: 0,
                      label: "Min size(pts)",
                      disabled: _setup.disabled.common,
                      debounce: 300,
                    },
                    on: {
                      debounce: function ($event) {
                        return _setup.updateFontSize(
                          "minSizePx",
                          _setup.model.minSize
                        )
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        !_setup.type.circularText
                          ? {
                              key: "append",
                              fn: function () {
                                return [
                                  _c(_setup.CButton, {
                                    attrs: { icon: ["far", "eye"], size: "sm" },
                                    on: {
                                      mousedown: function ($event) {
                                        return _setup.forceFontSize(
                                          _setup.model.minSize
                                        )
                                      },
                                      mouseup: _setup.resetForceFontSize,
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            }
                          : null,
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _setup.model.minSize,
                      callback: function ($$v) {
                        _vm.$set(_setup.model, "minSize", $$v)
                      },
                      expression: "model.minSize",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "mx-2" }, [_vm._v(" to ")]),
                  _vm._v(" "),
                  _c(_setup.CInput, {
                    staticClass: "flex-fill",
                    attrs: {
                      type: "decimal",
                      step: ".01",
                      min: 0,
                      placeholder: _setup.model.placeholder,
                      label: "Max size(pts)",
                      disabled: _setup.disabled.common,
                      debounce: 300,
                    },
                    on: {
                      debounce: function ($event) {
                        return _setup.updateFontSize(
                          "maxSizePx",
                          _setup.model.maxSize
                        )
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        !_setup.type.circularText
                          ? {
                              key: "append",
                              fn: function () {
                                return [
                                  _c(_setup.CButton, {
                                    attrs: { icon: ["far", "eye"], size: "sm" },
                                    on: {
                                      mousedown: function ($event) {
                                        return _setup.forceFontSize(
                                          _setup.model.maxSize
                                        )
                                      },
                                      mouseup: _setup.resetForceFontSize,
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            }
                          : null,
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _setup.model.maxSize,
                      callback: function ($$v) {
                        _vm.$set(_setup.model, "maxSize", $$v)
                      },
                      expression: "model.maxSize",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c(_setup.CSelect, {
                    attrs: {
                      options: _setup.horizontalAlignOptions,
                      label: "Horizontal alignment",
                      placeholder: _setup.model.placeholder,
                      "model-transform": _setup.valueReducer,
                      disabled: _setup.disabled.align,
                    },
                    on: {
                      input: function ($event) {
                        return _setup.updateElementProp("textAlign", $event)
                      },
                    },
                    model: {
                      value: _setup.model.textAlign,
                      callback: function ($$v) {
                        _vm.$set(_setup.model, "textAlign", $$v)
                      },
                      expression: "model.textAlign",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row" },
              [
                !_setup.type.circularText && !_setup.hasTextPathDraw
                  ? _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c(_setup.CSelect, {
                          staticClass: "flex-fill",
                          attrs: {
                            options: _setup.verticalAlignOptions,
                            label: "Vertical alignment",
                            placeholder: _setup.model.placeholder,
                            "model-transform": _setup.valueReducer,
                            disabled: _setup.disabled.align,
                          },
                          on: {
                            input: function ($event) {
                              return _setup.updateElementProp(
                                "textVerticalAlign",
                                $event
                              )
                            },
                          },
                          model: {
                            value: _setup.model.textVerticalAlign,
                            callback: function ($$v) {
                              _vm.$set(_setup.model, "textVerticalAlign", $$v)
                            },
                            expression: "model.textVerticalAlign",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c(_setup.CInput, {
                      staticClass: "flex-fill",
                      attrs: {
                        label: "Tracking",
                        step: 1,
                        type: "decimal",
                        placeholder: _setup.model.placeholder,
                        disabled: _setup.disabled.tracking,
                        "fraction-digits": 0,
                        pattern: /^[1-9]\d*$/,
                      },
                      on: {
                        input: function ($event) {
                          return _setup.updateElementProp("tracking", $event)
                        },
                      },
                      model: {
                        value: _setup.model.tracking,
                        callback: function ($$v) {
                          _vm.$set(_setup.model, "tracking", $$v)
                        },
                        expression: "model.tracking",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                !_setup.type.circularText
                  ? _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c(_setup.CInput, {
                          attrs: {
                            type: "decimal",
                            min: 0,
                            label: "Line spacing (%)",
                            placeholder: _setup.model.placeholder,
                            disabled: _setup.disabled.common,
                          },
                          on: { input: _setup.updateLineSpacing },
                          model: {
                            value: _setup.model.lineSpacing,
                            callback: function ($$v) {
                              _vm.$set(_setup.model, "lineSpacing", $$v)
                            },
                            expression: "model.lineSpacing",
                          },
                        }),
                      ],
                      1
                    )
                  : [
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _c(_setup.CInput, {
                            staticClass: "flex-fill",
                            attrs: {
                              type: "decimal",
                              step: ".01",
                              min: -9999999,
                              max: 9999999,
                              label: "String Start (dg)",
                              placeholder: _setup.model.placeholder,
                              disabled: _setup.disabled.common,
                            },
                            on: {
                              input: function ($event) {
                                return _setup.updateElementProp(
                                  "startAngle",
                                  $event
                                )
                              },
                            },
                            model: {
                              value: _setup.model.circularStartAngle,
                              callback: function ($$v) {
                                _vm.$set(
                                  _setup.model,
                                  "circularStartAngle",
                                  $$v
                                )
                              },
                              expression: "model.circularStartAngle",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _c(_setup.CInput, {
                            staticClass: "flex-fill",
                            attrs: {
                              type: "decimal",
                              step: ".01",
                              min: -9999999,
                              max: 9999999,
                              label: "String End (dg)",
                              placeholder: _setup.model.placeholder,
                              disabled: _setup.disabled.common,
                            },
                            on: {
                              input: function ($event) {
                                return _setup.updateElementProp(
                                  "endAngle",
                                  $event
                                )
                              },
                            },
                            model: {
                              value: _setup.model.circularEndAngle,
                              callback: function ($$v) {
                                _vm.$set(_setup.model, "circularEndAngle", $$v)
                              },
                              expression: "model.circularEndAngle",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
              ],
              2
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row align-items-center" }, [
        _setup.type.text && !_setup.hasTextPathDraw
          ? _c(
              "div",
              { staticClass: "col-4" },
              [
                _c(_setup.CCheckbox, {
                  attrs: {
                    label: "Automatic Multiline",
                    disabled: _setup.disabled.common || _setup.hasTextShape,
                  },
                  on: {
                    input: function ($event) {
                      return _setup.updateElementProp("multiline", $event)
                    },
                  },
                  model: {
                    value: _setup.model.multiline,
                    callback: function ($$v) {
                      _vm.$set(_setup.model, "multiline", $$v)
                    },
                    expression: "model.multiline",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _setup.type.circularText
          ? _c(
              "div",
              { staticClass: "col-4" },
              [
                _setup.type.circularText
                  ? _c(_setup.CSelect, {
                      staticClass: "flex-fill",
                      attrs: {
                        label: "Side",
                        options: _setup.textSideOptions,
                        placeholder: _setup.model.placeholder,
                        "model-transform": _setup.valueReducer,
                        disabled: _setup.disabled.common,
                      },
                      on: {
                        input: function ($event) {
                          return _setup.updateElementProp("convex", $event)
                        },
                      },
                      model: {
                        value: _setup.model.circularConvex,
                        callback: function ($$v) {
                          _vm.$set(_setup.model, "circularConvex", $$v)
                        },
                        expression: "model.circularConvex",
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-4" },
          [
            _c(_setup.CCheckbox, {
              attrs: { label: "All Caps", disabled: _setup.disabled.common },
              on: {
                input: function ($event) {
                  return _setup.updateElementProp("caps", $event)
                },
              },
              model: {
                value: _setup.model.caps,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "caps", $$v)
                },
                expression: "model.caps",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _setup.type.text && !_setup.hasTextPathDraw
          ? _c(
              "div",
              { staticClass: "col-4" },
              [
                !_setup.hasTextShape
                  ? _c(_setup.CCheckbox, {
                      attrs: {
                        label: "Vertical text",
                        disabled: _setup.disabled.common,
                      },
                      on: {
                        input: function ($event) {
                          return _setup.updateElementProp(
                            "verticalText",
                            $event
                          )
                        },
                      },
                      model: {
                        value: _setup.model.verticalText,
                        callback: function ($$v) {
                          _vm.$set(_setup.model, "verticalText", $$v)
                        },
                        expression: "model.verticalText",
                      },
                    })
                  : _c(_setup.CCheckbox, {
                      attrs: {
                        label: "Ignore Line Breaks",
                        disabled: _setup.disabled.common,
                      },
                      on: { input: _setup.updateIgnoreLineBreaks },
                      model: {
                        value: _setup.model.ignoreLineBreaks,
                        callback: function ($$v) {
                          _vm.$set(_setup.model, "ignoreLineBreaks", $$v)
                        },
                        expression: "model.ignoreLineBreaks",
                      },
                    }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }